import { AlertBadBrowser } from "../../../components/Alerts/AlertBadBrowser";
import { Favorites } from "../../../components/Favorites";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { SkeletonBox } from "../../../components/Loaders/SkeletonBox";
import { categoriesWithSvgPath } from "../../../../lib/constants";
import { getCategoryBackgroundColor, getSize } from "views/resources/theme";
import { isIE } from "react-device-detect";
import React, { useDispatch, useEffect, useGlobal, useState } from "reactn";
import logos from "views/resources/logos/SVG";
import styled from "styled-components";
import { useAuth } from "hooks/useAuth";
// const { Avatar: SkeletonBox } = Skeleton;

const HomeScreen = () => {
	const [categories] = useGlobal("categories");
	const [user] = useGlobal("user");

	const { isLoggedIn, isLoggedInTemporary } = useAuth();

	return (
		<>
			{isIE && <AlertBadBrowser></AlertBadBrowser>}
			<Content>
				<h3
					style={{
						fontSize: 25,
						color: "#163f8a",
						fontWeight: "bold",
					}}
				>
					Clientes
				</h3>

				<Categories categories={Object.values(categories.byId)} />
			</Content>
			<Content>
				{!isLoggedInTemporary && isLoggedIn && (
					<>
						<h3
							style={{
								fontSize: 25,
								color: "#163f8a",
								fontWeight: "bold",
							}}
						>
							Sucursales Favoritas
						</h3>
						<Favorites></Favorites>
					</>
				)}
			</Content>
		</>
	);
};

interface CategoriesProps {
	categories: Category[];
}

const Categories = ({ categories }: CategoriesProps) => {
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setLoading(true);
		if (categories.length) {
			setLoading(false);
		}
	}, [categories]);

	return loading ? (
		<Boxes>
			{Array.from(Array(14).keys()).map((_, i) => (
				<SkeletonBox key={i} style={{ margin: 12 }}></SkeletonBox>
			))}
		</Boxes>
	) : (
		<Boxes>
			{categories
				.filter((c) => c.slug !== "latam")
				.map((cat, i) => (
					<Box key={i} category={cat}>
						<p>{cat && cat.name}</p>
					</Box>
				))}
		</Boxes>
	);
};

interface BoxProps {
	children: string;
	category: Category;
}

const Box = ({ children, category, key }: BoxProps) => {
	const addCategoryFilter = useDispatch("addCategoryFilter");
	const removeDistrictFilter = useDispatch("removeDistrictFilter");
	const searchResultsSetup = async () => {
		await addCategoryFilter({ category });
		await removeDistrictFilter();
	};

	return (
		<StyledBox
			className="category-box"
			backgroundColor={getCategoryBackgroundColor(category.slug)}
			key={key}
			name={category.slug}
		>
			<Link
				to={`/search?category=${category.slug}`}
				onClick={() => searchResultsSetup()}
				name={category.slug}
			>
				{category.id !== 15 ? (
					<Logo
						keepSvgPath={categoriesWithSvgPath.includes(
							category.id
						)}
					>
						<ReactSVG
							src={
								logos["logo_" + category.id] || logos.servicios
							}
						/>
					</Logo>
				) : (
					<LogoBCI>
						<ReactSVG
							src={
								logos["logo_" + category.id] || logos.servicios
							}
						/>
					</LogoBCI>
				)}
			</Link>
			<Name>{children}</Name>
		</StyledBox>
	);
};

const Name = styled.div`
	margin: 6px 0 12px 0;
	font-weight: 600;
	font-size: ${getSize("sm")};
	text-align: center;
	align-self: center;
`;

const Boxes = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, 100px);
	grid-gap: 1rem;
	justify-content: space-between;
`;

const StyledBox = styled.div`
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	align-content: center;
	align-items: center;

	a {
		width: 88px;
		display: block;
		height: 89px;
		border-radius: 10px;
		background-color: ${({ backgroundColor }) => backgroundColor};
		margin: 1%;
		box-shadow: 0px 4px 2px 0px rgba(0, 0, 0, 0.27);
	}
`;

const Logo = styled.div`
	font-weight: bold;
	font-size: ${getSize("sm")};
	svg path {
		fill: ${(props) => (props.keepSvgPath ? "" : "#fff !important")};
	}

	height: 100%;

	div {
		height: 100%;
	}
`;

const LogoBCI = styled.div`
	font-weight: bold;
	font-size: ${getSize("sm")};
`;

const Content = styled.div`
	padding: ${getSize("m")} ${getSize("l")};
`;

export default HomeScreen;
